import React, { useEffect } from "react";
import { useStores } from "_common/hooks";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import i18next from "i18next";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { UserWalletApi } from "states/api/wallet";
import moment from "moment";

export default function WalletList() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const {
    authStore: { setBankSelect },
  } = useStores();

  const [params] = useSearchParams();

  const type = params?.get("type");

  const { data, refetch } = useQuery(
    ["user_wallet", "list"],
    () =>
      UserWalletApi.getList({
        params: {
          page: 1,
          limit: 50,
        },
      }),
    {
      staleTime: 300000,
    }
  );

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="container py-[80px]">
      <HeaderTop title={i18next.t("bind_wallet")} />

      {data?.data?.length > 0 ? (
        <div className="flex flex-col items-center gap-2 p-4 my-4">
          <img
            src="https://api.demo92.apptestlive.com/assets/images/atm.svg"
            alt="ATM"
            width="100"
            height="100"
            className="h-80 w-80"
          />
          {data?.data?.map((item) => (
            <div
              className="flex flex-col rounded bg-[#1c1c1e] w-full"
              key={item?.id}
            >
              <div className="flex justify-between border-b border-[#ffffff1a]">
                <div className="flex gap-2 items-center py-2 text-[#888] text-[16px]">
                  <div className="h-8 w-[3px] bg-[#f7a600]" />
                  <svg
                    viewBox="0 0 32 32"
                    width="32"
                    height="32"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.12,6H6.88A3.89,3.89,0,0,0,3,9.89V21.11A3.89,3.89,0,0,0,6.88,25H25.12A3.89,3.89,0,0,0,29,21.11V9.89A3.89,3.89,0,0,0,25.12,6ZM6.88,8H25.12A1.89,1.89,0,0,1,27,9.89V11H5V9.89A1.89,1.89,0,0,1,6.88,8ZM25.12,23H6.88A1.89,1.89,0,0,1,5,21.11V13H27v8.11A1.89,1.89,0,0,1,25.12,23Z"
                      fill="#f7a600"
                    />
                    <path d="M24,19H19a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z" />
                  </svg>
                  <span>{item?.bank_name}</span>
                  <div className="border border-[#2e7d32b3] text-[#2e7d32] text-xs rounded-2xl text-nowrap py-1 px-[7px]">
                    Đã xác minh
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-[2px] p-4 text-[15px] text-white">
                <span>{item?.bank_number_display}</span>
                <span className="text-[#888]">{item?.country}</span>
                <span className="text-[#888]">{item?.bank_name}</span>
                <span className="text-[#888]">{item?.address_contract}</span>
                <span className="text-[#888]">{item?.phone_display}</span>
                <span className="text-[#888]">{item?.card_id_display}</span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center px-4 my-4">
          <img
            src="https://api.demo92.apptestlive.com/assets/images/empty.svg"
            alt="No Withdraw Account"
            width="100"
            height="100"
            className="h-80 w-80"
          />
          <span className="text-[16px] text-[#888]">No Withdraw Account</span>
        </div>
      )}
      {!data?.data?.length && (
        <button
          type="button"
          className="btn btn-add-wallet"
          onClick={() => navigate("/member/add-wallet")}
        >
          {i18next.t("add_wallet_address")}
        </button>
      )}
    </div>
  );
}
